export default __webpack_public_path__ + "static/media/BodyNormal.be2e3576.jpg";